<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import ButtonAlt from "@/dsComponents/buttons/ButtonAlt.vue";
import TextEditorModal from "@/dsComponents/modals/TextEditorModal.vue";

interface InterviewSummaryReviewModalProps {
    open: boolean;
    isSaving: boolean;
}

defineProps<InterviewSummaryReviewModalProps>();

const summaryText = defineModel<string>("summaryText", { required: true });

const emit = defineEmits<{
    close: [];
    back: [];
    submit: [];
}>();

const { t } = useI18n();

const isSummaryEmpty = computed(() => (summaryText.value ?? "").trim().length === 0);
</script>

<template>
    <TextEditorModal
        v-model="summaryText"
        :placeholder="t('page.interim.profile.interview.placeholder')"
        :open="open"
        :title="t('page.interim.profile.interview.new')"
        :heading="t('page.interim.profile.interview.summaryTitle')"
        :disabled="isSaving"
        @close="emit('close')"
    >
        <template #footer-start>
            <ButtonAlt
                size="sm"
                type="neutral"
                variant="stroke"
                left-icon="arrow-left"
                :label="t('page.interim.profile.interview.backToEdit')"
                @click="emit('back')"
            />
        </template>
        <template #footer-end>
            <ButtonAlt
                size="sm"
                variant="filled"
                type="primary"
                :label="t('page.interim.profile.interview.validateSummary')"
                :loading="isSaving"
                :disabled="isSummaryEmpty"
                @click="emit('submit')"
            />
        </template>
    </TextEditorModal>
</template>
